"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Offers = Offers;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const antd_1 = require("antd");
const socket_context_1 = require("@src/context/socket-context");
const SteppedInfoPanel_1 = require("@src/components/modules/global/SteppedInfoPanel");
const types_1 = require("@src/types");
const SteppedInfoPanel_2 = require("@src/components/modules/global/SteppedInfoPanel/SteppedInfoPanel");
const account_context_1 = require("@src/context/account-context");
const admin_context_1 = require("@src/components/pages/admin/admin-context");
// import { getOfferPromotionActiveStatus } from '@src/helpers/getOfferPromotionStatus'
const queries_1 = require("@src/types/queries");
const react_query_1 = require("react-query");
const Offers_style_1 = require("./Offers.style");
const ArchiveOfferModal_1 = require("./modals/ArchiveOfferModal");
const OffersTabs_1 = require("./OffersTabs");
const OfferPublishedModal_1 = require("./modals/OfferPublishedModal");
const offer_promotion_context_1 = require("./offer-promotion-context");
// import { ScrapeExternalOfferModal } from './modals/ScrapeExternalOfferModal'
const NoOffersIllustration = () => ((0, jsx_runtime_1.jsxs)("div", { className: "flex-col justify-center align-center", children: [(0, jsx_runtime_1.jsx)(Offers_style_1.StyledCheckList, {}), (0, jsx_runtime_1.jsx)(Offers_style_1.IllustrationText, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.hiring_process" }) })] }));
function Offers() {
    const history = (0, react_router_dom_1.useHistory)();
    const intl = (0, react_intl_1.useIntl)();
    const socket = (0, socket_context_1.useSocket)();
    const account = (0, account_context_1.useAccount)();
    const [isArchiveModalOpen, setIsArchiveModalOpen] = react_1.default.useState(false);
    const [currentlyArchivedOffer, setCurrentlyArchivedOffer] = react_1.default.useState(null);
    // const [showScrapeExternalOfferModal, setShowScrapeExternalOfferModal] = React.useState(false)
    const { availableCredits } = (0, react_redux_1.useSelector)((state) => state.admin.company);
    const { myOffers, areMyOffersLoading, setIsOpenNotEnoughCreditsDialog, companyPremiumSettings } = (0, admin_context_1.useAdminContextValue)();
    const { setShowPromotionModal, promotingOffer, setPromotingOffer } = (0, offer_promotion_context_1.useOfferPromotionContextValue)();
    const queryClient = (0, react_query_1.useQueryClient)();
    const { hasFreeOfferPublishingEnabled } = companyPremiumSettings;
    const [isOfferPublishedModalOpen, setIsOfferPublishedModalOpen] = react_1.default.useState(Boolean(promotingOffer));
    const hasNoOffers = Object.values(myOffers).every(offerStatus => offerStatus.length === 0);
    const isAccountVerified = react_1.default.useMemo(() => {
        return Boolean(account === null || account === void 0 ? void 0 : account.verified);
    }, [account === null || account === void 0 ? void 0 : account.verified]);
    react_1.default.useEffect(() => {
        queryClient.invalidateQueries(queries_1.Queries.getMyOffers);
        socket.on(types_1.SocketEvents.MY_OFFERS_UPDATED, () => queryClient.invalidateQueries(queries_1.Queries.getMyOffers));
        return () => {
            socket.off(types_1.SocketEvents.MY_OFFERS_UPDATED, () => queryClient.invalidateQueries(queries_1.Queries.getMyOffers));
            setPromotingOffer(null);
        };
    }, []);
    const openArchiveModal = (offerId) => {
        const currentOffer = myOffers.active.find(o => o.id === offerId);
        setCurrentlyArchivedOffer(currentOffer);
        setIsArchiveModalOpen(true);
    };
    if (areMyOffersLoading) {
        return ((0, jsx_runtime_1.jsx)(elements_1.Panel, { className: "p-l", children: (0, jsx_runtime_1.jsx)(antd_1.Skeleton, { active: true }) }));
    }
    if (hasNoOffers) {
        const getStepsDescription = () => {
            const description = [intl.formatMessage({ id: 'admin.offers.start_hiring_process' })];
            if (!isAccountVerified) {
                description.push(intl.formatMessage({ id: 'admin.offers.email_check' }));
            }
            return description;
        };
        const steps = [
            {
                title: intl.formatMessage({
                    id: 'admin.offers.first_step',
                }),
                status: SteppedInfoPanel_2.InfoPanelStepStatus.done,
            },
            {
                title: intl.formatMessage({
                    id: 'admin.offers.second_step',
                }),
                status: SteppedInfoPanel_2.InfoPanelStepStatus.active,
            },
            {
                title: intl.formatMessage({
                    id: 'admin.offers.third_step',
                }),
                status: SteppedInfoPanel_2.InfoPanelStepStatus.toBeDone,
            },
        ];
        const onActiveClick = () => {
            if (availableCredits || hasFreeOfferPublishingEnabled) {
                history.pushLocalized('/admin/pridat-ponuku');
                return;
            }
            setIsOpenNotEnoughCreditsDialog(true);
        };
        return ((0, jsx_runtime_1.jsx)(SteppedInfoPanel_1.SteppedInfoPanel, { title: intl.formatMessage({ id: 'admin.offers.no_offers_title' }), description: getStepsDescription(), Illustration: NoOffersIllustration, steps: steps, onActiveClick: onActiveClick }));
    }
    return ((0, jsx_runtime_1.jsxs)(elements_1.Panel, { children: [(0, jsx_runtime_1.jsx)(OffersTabs_1.OffersTabs, { openArchiveModal: openArchiveModal }), (0, jsx_runtime_1.jsx)("div", { className: "p-l p-b-m", children: (0, jsx_runtime_1.jsx)(elements_1.Separator, { type: "horizontal" }) }), !isAccountVerified && ((0, jsx_runtime_1.jsx)("div", { className: "m-b-m text-center", children: (0, jsx_runtime_1.jsx)("p", { className: "m-b-none", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offers.verification_notice" }) }) })), (0, jsx_runtime_1.jsx)(Offers_style_1.ButtonsWrapper, { children: (0, jsx_runtime_1.jsx)(elements_1.Button, { className: "m-r-m", disabled: !isAccountVerified, onClick: () => history.pushLocalized('/admin/pridat-ponuku'), "data-cy": "add-offer", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offers.add_offer" }) }) }), (0, jsx_runtime_1.jsx)(ArchiveOfferModal_1.ArchiveOfferModal, { offer: currentlyArchivedOffer, isOpen: isArchiveModalOpen, close: () => setIsArchiveModalOpen(false) }), (0, jsx_runtime_1.jsx)(OfferPublishedModal_1.OfferPublishedModal, { isOpen: isOfferPublishedModalOpen, closeModal: () => setIsOfferPublishedModalOpen(false), onPromoteOfferButtonClick: () => {
                    setIsOfferPublishedModalOpen(false);
                    setShowPromotionModal(true);
                } })] }));
}
